import { Injectable, Injector } from '@angular/core';
import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { AuthService } from '../user-services/auth.service';
import { ConstService } from '../user-services/const.service';
import { filter } from 'rxjs/operators';
import {RouterEvent, Router, NavigationEnd} from '@angular/router';
import { CACHE_KEY } from './cache-header.interceptor';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {

  apiUri = this.constService.getApiUri();
  constructor(
    private authService: AuthService,
    private constService: ConstService,
    private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const noCache = req.headers.get(CACHE_KEY);

    if (this.router.url.includes('menu')) {
      this.authService.isLoggedIn().then(res => {
        if (!res) {
          this.authService.login();
        }
      });
    }

    if (noCache) {
      req = req.clone({
        headers: req.headers.delete(CACHE_KEY)
      }).clone({
        headers: req.headers.set('Cache-Control', 'private, no-cache, no-store, must-revalidate')
        .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
        .set('If-Modified-Since', '0')
      });
    }

    if (req.url.toLocaleUpperCase().startsWith(this.apiUri.toLocaleUpperCase())) {
      return from(this.authService.getAccessToken().then(token => {
        const header = req.headers.set('Authorization', `Bearer ${token}`);
        const authReq = req.clone({headers: header});
        return next.handle(authReq).toPromise();
      }));
    }

    return next.handle(req);
  }
}
